<template>
  <div class="editable_field" :class="{ 'editable-pointer': editable }">
    <div v-if="read" class="border-0" @click="enterEdit()">
      <div v-if="textEmpty && editable" class="whisper">
        {{ placeholder }}
      </div>
      <div v-else v-html="text" :class="textClasses" />
    </div>
    <!-- TODO: See if we can replace the clickaway with @focusout -->
    <div v-else v-on-clickaway="saveField" class="the_field">
      <div class="ghost_text" v-html="ghostText" />
      <textarea
        class="form-control"
        ref="editableFieldInput"
        :placeholder="placeholder"
        v-model="localValue"
        @keyup.enter.prevent="saveField"
        @keyup.esc.prevent="cancelEdit"
        @input="onInput"
      />
    </div>
  </div>
</template>
<script lang="ts">
import { mixin as clickaway } from 'vue-clickaway'

export default {
  mixins: [clickaway],
  props: {
    value: { type: String, default: '' },
    placeholder: { type: String, default: 'Enter text here' },
    editable: { type: Boolean, default: false },
    suffix: { type: String, default: '' },
    truncate: { type: Boolean, default: false },
  },
  emits: ['input', 'editable_field:save'],
  data() {
    return {
      read: true,
      original_value: null,
      localValue: this.value || '',
    }
  },
  computed: {
    textClasses() {
      return this.truncate ? 'text-truncate' : null
    },
    textEmpty() {
      return this.localValue === '' || this.localValue === null || this.localValue === 'null'
    },
    text() {
      return `${this.localValue}${this.suffix}`
    },
    ghostText() {
      if (this.text.length > 0) return this.text
      return '-' // This is important for the textarea to have a height
    },
  },
  watch: {
    value(newVal) {
      this.localValue = newVal
    },
    localValue(newVal) {
      this.$emit('input', newVal)
    },
  },
  mounted() {
    this.original_value = this.value
    this.localValue = this.value
  },
  methods: {
    enterEdit() {
      if (this.editable) this.read = false
      this.$nextTick(() => this.$refs.editableFieldInput.focus())
    },
    cancelEdit() {
      if (!this.read) {
        this.localValue = this.original_value
        this.$emit('input', this.original_value)
        this.read = true
      }
    },
    saveField() {
      const trimmedValue = this.localValue?.trim()
      this.localValue = trimmedValue
      this.$emit('input', trimmedValue)

      if (trimmedValue != this.original_value) {
        this.$emit('editable_field:save', trimmedValue)
        this.original_value = trimmedValue
      }
      this.read = true
    },
    onInput(event) {
      this.localValue = event.target.value
    },
  },
}
</script>
<style lang="sass" scoped>
.editable_field
  overflow-wrap: break-word
  &:hover
    cursor: text

.editable-pointer:hover
  cursor: pointer

.the_field
  position: relative
  padding: 0
  height: 100%

  .ghost_text
    visibility: hidden

  textarea.form-control
    position: absolute
    top: -0.2rem
    bottom: 0
    left: -0.2rem
    right: 0
    overflow: hidden

    padding-left: 0.14rem
    padding-top: 0.4rem

    font-family: inherit
    font-size: inherit
    font-weight: inherit
    font-feature-settings: 'cv01' on, 'salt' on

    height: auto
    resize: none
</style>
